import React, { useEffect, useState } from 'react';
import { ProofViewer } from './ProofViewer';
import * as S from '../styles';
import { useBatchJob } from '../../../../../context/BatchJobContext';
import axiosCall from '../../../../../utils/services/interceptor';
import { saveByteArray } from '../../../../../utils/javascript';

const Step4ProofBatch = () => {
  const {
    format,
    selectedTemplate,
    templates,
    proffDataList,
    setProffDataList,
    batchId,
    proofsApproved,
    setProofsApproved,
    totalProofCount,
    setTotalProofCount,
    draftBatchInfo,
    uploadedFile,
  } = useBatchJob();

  const [byteArray, setByteArray] = useState();
  return (
    <S.StepContent>
      <ProofViewer
        format={format}
        selectedTemplate={selectedTemplate}
        templates={templates}
        proffDataList={proffDataList}
        setProffDataList={setProffDataList}
        batchId={batchId}
        proofsApproved={proofsApproved}
        setProofsApproved={setProofsApproved}
        totalProofCount={totalProofCount}
        setTotalProofCount={setTotalProofCount}
        isDraft={draftBatchInfo !== undefined}
        uploadedFile={uploadedFile}
      />
    </S.StepContent>
  );
};

export default Step4ProofBatch;
